<panel>
    <h1>{{ 'pool.list-pools' | translate }}</h1>
    <list-view [emptyLabel]="'pool.pool-list-empty-label'">
        <header defaultSort="ascending">{{ 'general.name' | translate }}</header>
        <header></header>
        <row *listData="let pool from pools" [highlighted]="selectedPool == pool" (action)="displayPool(pool)">
            <column>{{ pool.name }}</column>
            <column align-right><icon small (click)="deletePool(pool)" type="trash" /></column>
        </row>
    </list-view>
    <section>
        <button small (click)="createPool()" [loader]="false" [ignoreValidation]="true"><icon type="plus" />{{ 'pool.create' | translate }}</button>
    </section>
</panel>
